import { render, staticRenderFns } from "./BasePromotion.vue?vue&type=template&id=26c1fe41&scoped=true"
import script from "./BasePromotion.vue?vue&type=script&lang=js"
export * from "./BasePromotion.vue?vue&type=script&lang=js"
import style0 from "./BasePromotion.vue?vue&type=style&index=0&id=26c1fe41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c1fe41",
  null
  
)

export default component.exports